<template>
    <section class="inNav_box">
        <div class="wrapper">
            <div class="inNav wow slideInUp" data-wow-duration="1s" data-wow-delay="200ms" >
                <router-link 
                    v-for="(item,index) in inNavInfo" 
                    :key="index" :to="item.url" 
                    :class="{active:item.selected}"

                >{{item.title}}</router-link>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    props:{
        bannerUrl:String,
        inNavInfo:Array
    },
    methods:{
       
    }
};
</script>

<style lang="scss" scoped>
@import '../../common/css/mixin.scss';

.inNav_box {
  .wrapper {
    .inNav {
      width: 100%;
      height: 80px;
      display: flex;
      align-items: center; 
      a {
            color: #333;
            font-size: 14px;
            padding: 3px 75px;
            border-right: 1px solid #d6d6d6;
            &:last-child {
                border: none;
            }
            &:hover,&.active{
                color: $themeColor;
            }

      }
    }
  }
}

</style>


// WEBPACK FOOTER //
// src/components/NavIn/NavIn.vue